import React, { useEffect, useState } from "react";
import { Modal, Button, Spin, Popconfirm } from "antd";
import { edit, trash } from "../../Utils/imports";
import {
  SwapOutlined,
  RedoOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { Checkbox, Form, Input } from "antd";
import { Space, Table, Tag } from "antd";
import {
  TableDataRole,
  Tableuser,
  Tableuserdata,
  access_capabilities,
} from "../../Utils/constants";
import NoDataFound from "../../Components/Helpers/NoDataFound";
import ButtonComp from "../../Components/ButtonComp/ButtonComp";
import RoleModal from "../../Components/Modaluser/roleModal";
import { PlantsettingsRoleVar } from "../../Utils/variables";
import defaultRoles from "../../Utils/defaultRoles";
import { useDispatch, useSelector } from "react-redux";
import "./plantSettings.css";
import { getRolesList } from "../../API-Interaction/apiServices/roles.api";
import { antIcon, formatCapabilities, canPerformAction } from "../../Helpers/helpers";
import { onDeleteRoleSubmit } from "../../API-Interaction/apiServices/plantSettings.api";
import { info } from "../../Components/Helpers/notification";
// import AddUserModal from '../Modaluser/AddUserModal';

const { heading } = PlantsettingsRoleVar;

const PlantsettingRole = () => {

  // let selector = useSelector(state => state?.plant?.current)
  const { pageLoaders } = useSelector(state => state?.utils.loaders)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [type, setType] = useState({ value: null, key: null })
  let { roleList } = useSelector(state => state?.roles)
  let { current } = useSelector(state => state?.plant)


  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  let dispatch = useDispatch()

  const onDeleteRole = (record) => {
    onDeleteRoleSubmit(dispatch, record)
  }

  const onEditRole = (record) => {
    // if (!current?.role?.capabilities?.includes(access_capabilities.canUpdateRoles))
      return info('Not authorized for action!')
    showModal();
    setType({ value: record, key: 'edit' })
  }
  const Tablerole = [
    {
      title: 'Role Name',
      dataIndex: 'role',
      key: 'role',
      width: "15%"

    },
    {
      title: 'Capabilities',
      key: 'capabilities',
      dataIndex: 'capabilities',
      render:

        (text, record) => (
          <>
            {record?.capabilities?.map(capability => <Tag key={capability} style={{ marginTop: 5 }}>{formatCapabilities(capability)}</Tag>)}
          </>
        ),
    },
    {
      title: 'Rights',
      dataIndex: 'rights',
      key: 'rights',
      render: (text, record) => record?.readOnly ? <Tag color="orange">Read only</Tag> : <Tag color="lightgray">N/A</Tag>,
      width: "10%",
      align: "center"

    },

  ];
  // if (canPerformAction(current, access_capabilities.hasPLantRoleAccess)) {
    Tablerole.push({ 
      title: 'Actions',
      key: 'action',
      align: 'right',
      render: (record) => (
        record?.readOnly ? <Tag color="lightgray">N/A</Tag> : <>
        <img src={edit} onClick={() => { showModal(); setType({ value: record, key: 'edit' }) }} style={{ width: "20px", cursor: "pointer", marginRight: "10px" }} />
        <Popconfirm placement="topRight" okText="Delete" cancelText="Cancel" okButtonProps={{className: "popRed"}} cancelButtonProps={{className: "popBlue"}} title="Confirm delete ?" onConfirm={() => { onDeleteRole(record) }}>
          <img src={trash} style={{ width: "20px", cursor: "pointer" }} />
        </Popconfirm>
      </>
      ),
      width: "10%",
      align: "center"
    })
  // }

  return (
    <Spin indicator={antIcon} spinning={pageLoaders?.plantSettings || pageLoaders?.addRole || pageLoaders?.updateRole || pageLoaders?.deleteRole || false}>

      <div className="dflex flexColumn gap20 pt1">
        <div className="lineOp_head dflex alignCenter justifySB">
          <h1 className="pageHead">{heading}</h1>
          <div className="dflex alignCenter justifyCenter gap10">
            {/* Add User Modal */}
            <ButtonComp
              onClick={() => { showModal(); setType({ value: "", key: 'add' }) }}
              theme={"blue"}
              text="Add Role"
              icon={<CloseCircleOutlined />}
            />
            <Modal
              title={<h2>{type.key === 'edit' ? "Edit Role" : "Add Role"}</h2>}
              footer={null}
              open={isModalOpen}
              maskClosable={false}
              onOk={handleOk}
              onCancel={handleCancel}
            >
              <RoleModal closeModal={handleCancel} type={type} />
            </Modal>
          </div>
        </div>
        <div className="lineOp_tale">
          {roleList?.length ?
            <Table columns={Tablerole} dataSource={roleList} x />
            :
            <Table columns={Tablerole} dataSource={defaultRoles} x />
          }
        </div>
      </div>
    </Spin>
  );
};
export default PlantsettingRole;
